import Logo from "@/components/Logo";
import { cn } from "@/lib/utils";

interface Props {
  /** Logo pixel size (mobile). */
  size?: number;
  className?: string;
  logoClassName?: string;
  /** Slightly larger type for roomy headers. */
  large?: boolean;
  /** In app-only compact landscape contexts, show the logo without the wordmark. */
  collapseOnCompactLandscape?: boolean;
}

/**
 * Single source of truth for the Tennis Log brand block (logo + fixed four-line lockup).
 * Used by the public header, the app header and the installed-app onboarding
 * screen so the wording is identical everywhere. Never truncates or ellipsises.
 */
export default function BrandBlock({
  size = 44,
  className,
  logoClassName,
  large = false,
  collapseOnCompactLandscape = false,
}: Props) {
  return (
    <span className={cn("flex shrink-0 items-center gap-2 sm:gap-3", className)}>
      <Logo size={size} className={cn("shrink-0", logoClassName)} />
      <span className={cn("shrink-0", collapseOnCompactLandscape && "lscompact:hidden")}>
        {/* Both wordmark lines share identical typography and scale together. */}
        <span
          className={cn(
            "block font-display font-normal leading-none",
            large ? "text-sm sm:text-xl md:text-2xl" : "text-sm sm:text-lg md:text-xl",
          )}
        >
          <span className="block whitespace-nowrap">
            TENNIS <span className="text-primary">LOG</span>
          </span>
          <span className="mt-1 block whitespace-nowrap">
            MY TENNIS <span className="text-primary">LEDGER</span>
          </span>
        </span>
        <span className="mt-1.5 block text-[9px] sm:text-[11px] md:text-xs text-muted-foreground leading-none">
          <span className="block whitespace-nowrap">Log matches.</span>
          <span className="mt-0.5 block whitespace-nowrap">Understand stats. Improve.</span>
        </span>
      </span>
    </span>
  );
}
